import { LEGAL_META, LEGAL_PATHS } from '../../content/legal/legalMeta';

const FOOTER_LINKS: { href: string; label: string }[] = [
  { href: LEGAL_PATHS.privacy, label: 'Privacy Policy' },
  { href: LEGAL_PATHS.terms, label: 'Terms of Service' },
  { href: LEGAL_PATHS.communityGuidelines, label: 'Community Guidelines' },
  { href: LEGAL_PATHS.childSafetyStandards, label: 'Child Safety Standards' },
  { href: LEGAL_PATHS.cookies, label: 'Cookie Policy' },
  { href: LEGAL_PATHS.support, label: 'Support' },
  { href: LEGAL_PATHS.deleteData, label: 'Delete Your Data' },
  { href: LEGAL_PATHS.accountDeletion, label: 'Account Deletion' },
];

export function LegalFooter() {
  return (
    <footer className="landing-footer-snap border-t border-neutral-soft bg-white mt-12 py-10 px-4 sm:px-6 max-md:mt-0 max-md:snap-start max-md:pb-[calc(2.5rem+env(safe-area-inset-bottom,0px))]">
      <div className="max-w-3xl mx-auto flex flex-col gap-6">
        <nav aria-label="Legal pages" className="flex flex-wrap gap-x-4 gap-y-2">
          {FOOTER_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm text-[#638888] hover:text-primary underline-offset-2 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 rounded"
            >
              {link.label}
            </a>
          ))}
        </nav>
        <p className="text-xs text-[#638888]">
          © {new Date().getFullYear()} {LEGAL_META.brandMark}. Contact:{' '}
          <a href={`mailto:${LEGAL_META.contactEmail}`} className="text-primary hover:underline">
            {LEGAL_META.contactEmail}
          </a>
        </p>
      </div>
    </footer>
  );
}
